<template>
  <div class="flex w-full flex-1 flex-col items-center px-6">
    <div class="flex w-full max-w-[450px] flex-grow flex-col">
      <div class="my-auto">
        <MembershipCard
          :name="name"
          interactive
          shadow
          class="mx-auto w-full max-w-[260px] tablet-h:max-w-[306px]"
        />

        <h1
          class="mt-[28px] text-center text-[28px] font-medium leading-[34px] tablet-h:text-[32px] tablet-h:leading-[38px]"
        >
          <span class="text-gray-400">Take your place</span>
          <br />
          <span class="text-gray-800">on the record.</span>
        </h1>

        <div
          class="mx-auto mt-[24px] max-w-[360px] text-center font-normal text-[16px] leading-[22px] text-gray-800"
        >
          <p>
            <span class="font-medium">
              Dacr Pro is membership in the global community of protected
              creators</span
            >—your Membership Card, member events, benefits, and resource
            library.
          </p>
          <p class="mt-[18px]">
            Membership fees advance stronger creator rights worldwide.
          </p>
        </div>
      </div>

      <Button class="w-full" variant="primary" size="lg" @click="handleClick">
        Become a member
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { Button } from '@dacr/library'

import MembershipCard from '@/shared/components/MembershipCard.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useUserStore } from '@/shared/stores/user'

const router = useRouter()
const userStore = useUserStore()
const { mutate: completeStep } = useCompleteStepMutation()

const name = computed(() => userStore.user?.name ?? '')

const handleClick = () => {
  completeStep({ step: 12 })
  router.push('/onboarding/pro')
}
</script>
